import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http"
import {Injectable} from "@angular/core"
import {Observable, throwError} from "rxjs"
import {catchError} from "rxjs/operators"
import {CurrentUserStore} from "app/common/services/current-user/CurrentUserStore"

@Injectable()
export class UnauthorizedResponseInterceptor implements HttpInterceptor {

    constructor(private userStore: CurrentUserStore) {

    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
                   .pipe(catchError((err) => this.handleErrorResponse(err)));
    }

    private handleErrorResponse(error: HttpErrorResponse): Observable<HttpEvent<any>> {
        if (error.status === 401) {
            this.userStore.clearUser();
        }
        return throwError(error);
    }
}
